import { useLanguage } from "../../components/LanguageProvider/LanguageProvider";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import Applications from "../../components/User/Applications";
import { applicationStatusMap } from "../../config/applicationStatusConfig";

const ApprovedApplicatons = () => {
  const { language, setLanguage } = useLanguage();
  return (
    <DashboardLayout pageTitle={language ? "आवेदन" : "Application"} mainClass="p-6">
      <Applications
        title={language ? "मंजूर आवेदन" : "Approved Applications"}
        status={[applicationStatusMap?.approved]}
      />
    </DashboardLayout>
  );
};

export default ApprovedApplicatons;
